var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative bg-black overflow-hidden",staticStyle:{"height":"0","padding-bottom":"70%"}},[_c('div',{ref:"wrap",staticClass:"absolute inset-0",staticStyle:{"top":"-51px !important"}},[_c('iframe',{staticClass:"w-full",style:({ height: `${_vm.height}px` }),attrs:{"src":_vm.sourceUrl,"kwframeid":"1","scrolling":"no"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }